import axios from "axios";
import { apiUrl } from "../environment";

export const bankInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json, text/plain, */*",
    Authorization:
      "Bearer b4bcde83803eab2ba7101cba9d22498a12b500f3c689620fbb21eeacb1029632",
  },
});

const baseURL = apiUrl;

const axiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json, text/plain, */*",
  },
});

const onRequest = (request) => {
  const access = JSON.parse(localStorage.getItem("id"));
  const user = JSON.parse(localStorage.getItem("user"));
  if (user) {
    request.headers.Authorization = `Bearer ${user?.accessToken}` || "";
    request.headers["t-token"] = user?.user?.transactionPin;
  } else {
    request.headers.Authorization = `Bearer ${access?.accessToken}` || "";
  }
  return request;
};

const onRequestError = (error) => {
  return Promise.reject(error);
};

const onResponse = (response) => {
  return response;
};

const onResponseError = (error) => {
  const statusCode = error?.response?.status;
  if (statusCode === 401) {
    localStorage.removeItem("user");
    setTimeout(() => {
      window.location.href = "/login";
    }, 500);
  }
  return Promise.reject(error);
};

// https://axios-http.com/docs/interceptors
axiosInstance.interceptors.request.use(onRequest, onRequestError);
axiosInstance.interceptors.response.use(onResponse, onResponseError);

export default axiosInstance;
